/**
 * @format
 */

import React, { useMemo } from 'react';
import SalesSummaryContainer from 'features/dashboard/containers/SalesSummaryContainer';
import MonthlySalesChartContainer from 'features/dashboard/containers/MonthlySalesChartContainer';
import WeeklyPremiumContainer from 'features/dashboard/containers/WeeklyPremiumContainer';
import { DashboardQueryParams } from 'features/dashboard/types/dashboard.types';

interface AffiliateSummaryContainerProps {
  officeId?: string;
}

const AffiliateSummaryContainer: React.FC<AffiliateSummaryContainerProps> = ({ officeId }) => {
  // Create params for office filtering
  const params: DashboardQueryParams = useMemo(() => {
    return {
      officeId,
    };
  }, [officeId]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <SalesSummaryContainer params={params} />
      <MonthlySalesChartContainer params={params} />
      <WeeklyPremiumContainer params={params} />
    </div>
  );
};

export default AffiliateSummaryContainer;
